export const initLinkedInTag = () => {
    // Prevent multiple initializations
    if (window._linkedin_data_partner_ids?.includes("7193084")) return;
  
    // Initialize LinkedIn partner ID
    window._linkedin_partner_id = "7193084";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
  
    // Load LinkedIn Insight Tag script
    (function (l) {
      if (!l) {
        window.lintrk = function (a, b) {
          window.lintrk.q.push([a, b]);
        };
        window.lintrk.q = [];
      }
      const s = document.getElementsByTagName("script")[0];
      const b = document.createElement("script");
      b.type = "text/javascript";
      b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);
    })(window.lintrk);
  
    // Add noscript fallback dynamically
    const noscript = document.createElement("noscript");
    const img = document.createElement("img");
    img.height = 1;
    img.width = 1;
    img.style.display = "none";
    img.alt = "";
    img.src = "https://px.ads.linkedin.com/collect/?pid=7193084&fmt=gif";
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  };
  
  export const trackLinkedInConversion = (conversionId) => {
    if (window.lintrk) {
      window.lintrk("track", { conversion_id: conversionId });
    }
  };